import { get, isEmpty } from 'lodash';

/**
 * Activates the waypoint edition in the waypoint layer.
 *
 * @param {*} arg - The object argument.
 * @param {boolean} arg.editWayPointsActive - Flag that marks that the edition of the waypoints has been turned on.
 * @param {boolean} arg.isElevationProfileLoading - Flag that marks that the elevation profile is loading.
 * @param {object} arg.geoJSONRpaPathLayer - The rpa path layer in leaflet.
 */
const activateWaypointEdition = ({
  editWayPointsActive,
  isElevationProfileLoading,
  geoJSONRpaPathLayer
}) => {
  const isRpaPathLayerEmpty = isEmpty(geoJSONRpaPathLayer.getLayers());
  if (!isRpaPathLayerEmpty) {
    const shouldFixLeafletDraw = get(geoJSONRpaPathLayer, 'getLayers()[0].options.editing', false);
    if (shouldFixLeafletDraw) {
      // This is a fix for issue https://github.com/Leaflet/Leaflet.draw/issues/804
      // eslint-disable-next-line no-param-reassign
      geoJSONRpaPathLayer.getLayers()[0].options.editing = {};
    }
    if (editWayPointsActive && !isElevationProfileLoading) {
      geoJSONRpaPathLayer.getLayers()[0].editing.enable();
    } else if (!editWayPointsActive || isElevationProfileLoading) {
      geoJSONRpaPathLayer.getLayers()[0].editing.disable();
    }
  }
};

export default activateWaypointEdition;
